export class ListOfTimeModelResponse {
	model_id: number;
	model_name: string;
}
